module.exports = __webpack_public_path__ + "static/media/instructor-why-targets-werent-hit.d4e76c91.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/instructor-why-targets-werent-hit.png
// module id = 2660
// module chunks = 0